import { render, staticRenderFns } from "./SignInController.vue?vue&type=template&id=2b889922&scoped=true"
import script from "./SignInController.vue?vue&type=script&lang=js"
export * from "./SignInController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b889922",
  null
  
)

export default component.exports